<template>
    <LayoutBase>
        <div id="global-event-listener-div" :class="{ 'page_container': true, 'is-admin': isAdmin }">
            <div :class="['page_sidenav', {'with_notification': hasNotification}]">
                <page-sidenav/>
            </div>

            <div v-if="hasNotification" class="page_notification">
                <page-notification/>
            </div>

            <div :class="['page_header', {'with_notification': hasNotification}]">
                <page-header/>
            </div>

            <div :class="['page_main', {'with_notification': hasNotification, 'is-not-scrollable': isNotScrollable}]">
                <slot/>

                <p v-if="!hideCopyright" class="page_main--copyright">© 2019 - {{ new Date().getFullYear() }} Forefront CRM | Contact Support: support@forefrontcrm.com</p>
            </div>

            <div id="page-modals">
                <hash-modals/>
                <slot name="modals"/>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
import PageHeader from "./PageHeader";
import PageSidenav from "./PageSidenav";
import localStorageService from "../../services/localStorage";
import HashModals from "./HashModals";
import PageNotification from "./PageNotification";
import LayoutBase from "../base/LayoutBase.vue";

export default {
  name: "LayoutPage",
  components: {LayoutBase, PageNotification, HashModals, PageSidenav, PageHeader},
  props: {
    isNotScrollable: {
      type: Boolean,
      default: false
    },
    hideCopyright: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    document.getElementById('global-event-listener-div').addEventListener("click", (event) => {
      this.$store.commit('setRealEstateOptionsOpen', event.target.className.includes("dont-close-search-results"))
    }, true);

    // This is here so that html, body, and #app have height set via css
    const root = document.documentElement
    root.classList.add('layout_page')
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
    hasNotification() {
      return this.account.is_near_record_limit || this.account.is_at_record_limit;
    },
    isAdmin() {
      return localStorageService.getAdminMode();
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.page_container {
  position: relative;
  min-height: 100%;
  min-width: $layoutMinWidth;
  padding-top: $headerHeight;
  padding-left: $sidenavWidth;
  background-color: $background;

  &.is-admin {

    .page_header,
    .page_sidenav {
      background-color: transparentize($red, 0.8);
    }
  }
}

.page_notification {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2;
  height: $notificationHeight;
  padding: 0 20px;
}

.page_header {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2;
  height: $headerHeight;
  padding: 0 20px;
  background-color: $white;
  border-left: 1px solid $border;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &.with_notification {
    top: $notificationHeight;
  }
}

.page_sidenav {
  position: absolute;
  top: $headerHeight;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: $sidenavWidth;
  padding: 4px 0;
  background-color: $white;
  border-top: 1px solid $border;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);

  &.with_notification {
    top: $notificationHeight + $headerHeight;
  }
}

.page_main {
  position: absolute;
  top: $headerHeight;
  right: 0;
  bottom: 0;
  left: $sidenavWidth;
  z-index: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0 $pagePaddingHorizontal;

  &.with_notification {
    top: $notificationHeight + $headerHeight;
  }

  &.is-not-scrollable {
    overflow-y: hidden;
    padding: 0;
  }

  &--copyright {
    margin: 1rem 0;
    color: $text-light;
    text-align: center;
  }
}
</style>
